// src/components/Configurator/renderers/Outlet2Renderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES } from "../configuratorConstants";
import { ReactComponent as ActualSocketX2Svg } from '../../Assets/socketx2.svg';

const Outlet2Renderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
  // wallOrientationType, 
}) => {
  const outletDefaults = defaultObjectSizes[OBJECT_TYPES.OUTLET_DOUBLE];
  const elementVisualWidthM = element.width || outletDefaults.width;
  const elementVisualHeightM = element.height || outletDefaults.height;
  const elementDepthM = element.depth || outletDefaults.depth || 0.01;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementVisualHeightPx = elementVisualHeightM * scale;
  const wallThicknessPx = wallThickness * scale;
  const elementDepthPx = elementDepthM * scale;

  const yOffset = placementSideFactor * ( (wallThicknessPx / 2) + (elementDepthPx / 2) );

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "rgba(229, 231, 235, 0.95)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "rgba(107, 114, 128, 0.8)",
    strokeWidth: isSelected ? 1.2 / (scale / 50) : 0.6 / (scale / 50),
    transition: "fill 0.1s ease-out, stroke 0.1s ease-out",
  };

  let svgSpecificTransform = "";
  if (placementSideFactor === 1) {
    svgSpecificTransform = "rotate(0)";
  } else if (placementSideFactor === -1) {
    svgSpecificTransform = "scale(1, -1)";
  }

  const finalSvgWidthRaw = elementVisualWidthPx / 1.9;
  const finalSvgDisplayWidth = finalSvgWidthRaw * 1.4;
  const ySvgOffset = -elementVisualHeightPx * 0.3;

  return (
    <g transform={`translate(0, ${yOffset})`}>
      <g transform={svgSpecificTransform}>
        <ActualSocketX2Svg
         x={-elementVisualWidthPx / 2} 
          y={-elementVisualHeightPx / 6}
          width={elementVisualWidthPx / 0.9}
          height={elementVisualHeightPx}
          style={svgStyle}
        />
      </g>
    </g>
  );
};

export default React.memo(Outlet2Renderer);